var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            ref: "confirmModal",
            attrs: {
              onModalClose: () => (_vm.modalData = null),
              onModalAccept: () => _vm.acceptRecord(null, true, true),
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "table table-sm table-hover border mb-1 mt-1" },
        [
          _c(
            "tbody",
            _vm._l(_vm.records ?? [], function (e) {
              return (+_vm.confirmStatus &&
                +e.is_confirmed !== +_vm.confirmStatus) ||
                !e.is_confirmed
                ? _c("tr", { key: e.id }, [
                    _c("td", { staticClass: "fix_width" }, [
                      _vm._v(
                        _vm._s(_vm.printDate(e.report_date, "DD.MM.YYYY"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "fix_big_width" }, [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$AllDivisions[e.division_id]?.title)),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-muted" }, [
                        _vm._v("инкассация"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.comment))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "fix_width" }, [
                      _vm._v(
                        _vm._s(_vm.$AllCurrencies[e.currency_id]?.currency) +
                          " "
                      ),
                      _c("strong", [_vm._v(_vm._s(e.sum))]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "fix_width", attrs: { align: "right" } },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-group" },
                          [
                            !_vm.hideReject
                              ? _c("LoadingButton", {
                                  attrs: {
                                    title:
                                      '<i class="icon-fa icon-fa-remove"/>',
                                    type: "button",
                                    loading: _vm.btnLoading[e.id],
                                    color: _vm.$constants.DANGER_COLOR,
                                    onClick: () => _vm.acceptRecord(e.id, true),
                                    className: "btn btn-outline-danger",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("LoadingButton", {
                              attrs: {
                                title: '<i class="icon-fa icon-fa-check"/>',
                                type: "button",
                                loading: _vm.btnLoading[e.id],
                                color: _vm.$constants.SUCCESS_COLOR,
                                onClick: () => _vm.acceptRecord(e.id),
                                className: "btn btn-success",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ])
                : _vm._e()
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }